(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[91],{

/***/ 73238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ BreadcrumbLink; },
/* harmony export */   "aG": function() { return /* binding */ Breadcrumb; },
/* harmony export */   "gN": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* unused harmony exports BreadcrumbSeparator, useBreadcrumbStyles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34031);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15818);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54520);
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28387);
// ../../../react-shim.js


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");

// src/breadcrumb.tsx




// src/breadcrumb-context.ts

var [BreadcrumbStylesProvider, useBreadcrumbStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  name: `BreadcrumbStylesContext`,
  errorMessage: `useBreadcrumbStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Breadcrumb />" `
});

// src/breadcrumb.tsx
var Breadcrumb = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function Breadcrumb2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useMultiStyleConfig */ .jC)("Breadcrumb", props);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  const {
    children,
    spacing = "0.5rem",
    separator = "/",
    className,
    listProps,
    ...rest
  } = ownProps;
  const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__/* .getValidChildren */ .W)(children);
  const count = validChildren.length;
  const clones = validChildren.map((child, index) => (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
    separator,
    spacing,
    isLastChild: count === index + 1
  }));
  const _className = cx("chakra-breadcrumb", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.nav */ .m$.nav, {
    ref,
    "aria-label": "breadcrumb",
    className: _className,
    __css: styles.container,
    ...rest
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.ol */ .m$.ol, {
    className: "chakra-breadcrumb__list",
    ...listProps,
    __css: {
      display: "flex",
      alignItems: "center",
      ...styles.list
    }
  }, clones)));
});
Breadcrumb.displayName = "Breadcrumb";

// src/breadcrumb-item.tsx



// src/breadcrumb-separator.tsx

var BreadcrumbSeparator = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbSeparator2(props, ref) {
  const { spacing, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const separatorStyles = {
    mx: spacing,
    ...styles.separator
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
    ref,
    role: "presentation",
    ...rest,
    __css: separatorStyles
  });
});
BreadcrumbSeparator.displayName = "BreadcrumbSeparator";

// src/breadcrumb-link.tsx

var BreadcrumbLink = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbLink2(props, ref) {
  const { isCurrentPage, as, className, href, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const sharedProps = {
    ref,
    as,
    className: cx("chakra-breadcrumb__link", className),
    ...rest
  };
  if (isCurrentPage) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
      "aria-current": "page",
      __css: styles.link,
      ...sharedProps
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.a */ .m$.a, {
    __css: styles.link,
    href,
    ...sharedProps
  });
});
BreadcrumbLink.displayName = "BreadcrumbLink";

// src/breadcrumb-item.tsx

var BreadcrumbItem = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbItem2(props, ref) {
  const {
    isCurrentPage,
    separator,
    isLastChild,
    spacing,
    children,
    className,
    ...rest
  } = props;
  const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__/* .getValidChildren */ .W)(children);
  const clones = validChildren.map((child) => {
    if (child.type === BreadcrumbLink) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        isCurrentPage
      });
    }
    if (child.type === BreadcrumbSeparator) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        spacing,
        children: child.props.children || separator
      });
    }
    return child;
  });
  const styles = useBreadcrumbStyles();
  const itemStyles = {
    display: "inline-flex",
    alignItems: "center",
    ...styles.item
  };
  const _className = cx("chakra-breadcrumb__list-item", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.li */ .m$.li, {
    ref,
    className: _className,
    ...rest,
    __css: itemStyles
  }, clones, !isLastChild && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbSeparator, {
    spacing
  }, separator));
});
BreadcrumbItem.displayName = "BreadcrumbItem";



/***/ }),

/***/ 35582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Meta; },
/* harmony export */   "s": function() { return /* binding */ OpenGraphType; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var lib_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22498);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


 // NOTE: copied from next-seo since it doesn't export this type.



var OpenGraphType;

(function (OpenGraphType) {
  OpenGraphType["WEBSITE"] = "website";
  OpenGraphType["ARTICLE"] = "article";
})(OpenGraphType || (OpenGraphType = {}));

var Meta = function Meta(_ref) {
  var titlePrefix = _ref.titlePrefix,
      _ref$titleSeparator = _ref.titleSeparator,
      titleSeparator = _ref$titleSeparator === void 0 ? '|' : _ref$titleSeparator,
      _ref$titleSuffix = _ref.titleSuffix,
      titleSuffix = _ref$titleSuffix === void 0 ? lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .SITE_NAME */ .px : _ref$titleSuffix,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? OpenGraphType.WEBSITE : _ref$type,
      description = _ref.description,
      _ref$seo = _ref.seo,
      seo = _ref$seo === void 0 ? {
    openGraph: {
      images: []
    }
  } : _ref$seo,
      _ref$relativeUrl = _ref.relativeUrl,
      relativeUrl = _ref$relativeUrl === void 0 ? '' : _ref$relativeUrl;
  var title = "".concat(titlePrefix, " ").concat(titleSeparator, " ").concat(titleSuffix);
  var url = "".concat("https://www.cutintothejamstack.com").concat(relativeUrl);

  var openGraph = _objectSpread({
    url: url,
    title: title,
    description: description,
    site_name: lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .SITE_NAME */ .px,
    type: type
  }, seo.openGraph);

  var twitter = _objectSpread({
    handle: '@mcavaliere',
    cardType: 'summary'
  }, seo.twitter);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, _objectSpread({
      title: title,
      description: description,
      openGraph: openGraph,
      twitter: twitter
    }, seo))
  });
};

/***/ }),

/***/ 34624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ BreadcrumbLink; },
/* harmony export */   "rU": function() { return /* binding */ Link; }
/* harmony export */ });
/* unused harmony export Button */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40639);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73238);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["children", "href"],
    _excluded2 = (/* unused pure expression or super */ null && (["children", "href"])),
    _excluded3 = ["children", "href"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var Link = function Link(_ref) {
  var children = _ref.children,
      href = _ref.href,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    href: href,
    passHref: true,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }))
  });
};
var Button = function Button(_ref2) {
  var children = _ref2.children,
      href = _ref2.href,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsx(NextLink, {
    href: href,
    passHref: true,
    children: /*#__PURE__*/_jsx(ChakraButton, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }))
  });
};
var BreadcrumbLink = function BreadcrumbLink(_ref3) {
  var children = _ref3.children,
      href = _ref3.href,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref3, _excluded3);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    href: href,
    passHref: true,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .BreadcrumbLink */ .At, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }))
  });
};

/***/ }),

/***/ 79102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ MaxWidthContainer; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40639);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var MaxWidthContainer = function MaxWidthContainer(_ref) {
  var children = _ref.children,
      rest = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, _objectSpread(_objectSpread({
    maxW: "5xl",
    w: "100%"
  }, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 80369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getLayout; }
/* harmony export */ });
/* unused harmony export MaxWidthContainerLayout */
/* harmony import */ var components_MaxWidthContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79102);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var MaxWidthContainerLayout = function MaxWidthContainerLayout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_MaxWidthContainer__WEBPACK_IMPORTED_MODULE_0__/* .MaxWidthContainer */ .a, {
    my: 20,
    children: children
  });
};
var getLayout = function getLayout(page) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MaxWidthContainerLayout, {
    children: page
  });
};

/***/ }),

/***/ 75970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ ArticlesIndexPage; }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(40639);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/index.esm.js
var dist_index_esm = __webpack_require__(8395);
// EXTERNAL MODULE: ./components/Link/index.tsx
var Link = __webpack_require__(34624);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/ArticlePreview/index.tsx





var ArticlePreview = function ArticlePreview(_ref) {
  var title = _ref.title,
      excerpt = _ref.excerpt,
      slug = _ref.slug;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
      mb: 2,
      direction: "column",
      width: "100%",
      alignItems: "flex-start",
      as: "article",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
        as: "h2",
        fontSize: "2xl",
        textAlign: "left",
        display: "block",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* Link */.rU, {
          href: "/articles/".concat(slug),
          textDecoration: "none",
          _hover: {
            textDecoration: 'none'
          },
          children: title
        })
      }), excerpt && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        as: "p",
        marginTop: "2",
        color: (0,dist_index_esm/* useColorModeValue */.ff)('gray.700', 'gray.200'),
        fontSize: "md",
        fontWeight: "normal",
        children: excerpt
      })]
    })
  });
};
// EXTERNAL MODULE: ./layouts/MaxWidthContainerLayout.tsx
var MaxWidthContainerLayout = __webpack_require__(80369);
// EXTERNAL MODULE: ./layouts/SiteOuterLayout.tsx + 66 modules
var SiteOuterLayout = __webpack_require__(61607);
;// CONCATENATED MODULE: ./layouts/AritclesIndexLayout.tsx



var ArticlesIndexLayout = function ArticlesIndexLayout(_ref) {
  var children = _ref.children;
  return children;
};
var getLayout = function getLayout(page) {
  return (0,SiteOuterLayout/* getLayout */.G0)((0,MaxWidthContainerLayout/* getLayout */.G)( /*#__PURE__*/(0,jsx_runtime.jsx)(ArticlesIndexLayout, {
    children: page
  })));
};
ArticlesIndexLayout.getLayout = getLayout;
// EXTERNAL MODULE: ./components/HeadContent/index.tsx
var HeadContent = __webpack_require__(35582);
;// CONCATENATED MODULE: ./pages/articles/index.tsx







var __N_SSG = true;
function ArticlesIndexPage(_ref) {
  var articlesMetaData = _ref.articlesMetaData,
      ogImageUrl = _ref.ogImageUrl,
      url = _ref.url;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeadContent/* Meta */.h, {
      titlePrefix: "Full-Stack Jamstack Articles",
      description: "Articles about building full-stack web applications with next-generation JavaScript libraries, including React, Next.js, Chakra-UI, Prisma ORM and more.",
      seo: {
        openGraph: {
          url: url,
          images: [{
            url: ogImageUrl,
            width: 1200,
            height: 628,
            alt: 'Jamstack Logo'
          }]
        }
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
        textAlign: "center",
        size: "xl",
        as: "h1",
        fontWeight: 600,
        mb: 12,
        children: "Recent Articles"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
        w: {
          base: '100%',
          md: '60%'
        },
        m: "0 auto",
        spacing: "15px",
        children: articlesMetaData.map(function (_ref2) {
          var _ref2$data = _ref2.data,
              title = _ref2$data.title,
              excerpt = _ref2$data.excerpt,
              slug = _ref2.slug;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(ArticlePreview, {
            slug: slug,
            title: title,
            excerpt: excerpt
          }, slug);
        })
      })]
    })]
  });
}
ArticlesIndexPage.getLayout = getLayout;

/***/ }),

/***/ 65615:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles",
      function () {
        return __webpack_require__(75970);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(65615); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);